const Whats = () => {
    return (
        <section>
            <div className="flex flex-col items-center pt-36 container">
                <h2 className="font-bold text-4xl mb-3 max-w-[750px] leading-normal text-gray-800">
                    <span className="text-primary">درچسب</span> چیست؟
                </h2>
                <p className="text-xl font-medium text-gray-700 leading-relaxed">
                    درچسب یک پلتفرم هوشمند تبلیغات محیطی است که با اتصال رانندگان به برندها، راهی نو برای دیده‌شدن
                    کسب‌وکارها ایجاد می‌کند.
                    رانندگان می‌توانند با چسباندن تبلیغات روی خودروهای شخصی یا کاری خود، از مسیرهای روزمره‌شان درآمد کسب
                    کنند.
                    در سوی دیگر، کسب‌وکارها از طریق درچسب می‌توانند پیام خود را به شکل خلاقانه و متحرک در معرض دید
                    هزاران نفر در سطح شهر قرار دهند.
                    تبلیغاتی که همراه با مردم حرکت می‌کنند — موثر، هدفمند و قابل‌سنجش.
                </p>


            </div>
        </section>

    );
};

export default Whats;
